import Vue from "vue";

export async function get() {
  const response = await Vue.prototype.$http.get(`/dashboard`);

  return response.data;
}
